import { useLocation, useParams } from 'react-router-dom';
import { Menu, UnstyledButton, Group, Text, rem } from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconUsers, IconPlaneTilt, IconTableShortcut, IconUserPlus, IconChevronDown } from '@tabler/icons-react';
import classes from './app-header-menu.module.css';

function HeaderMenu() {
  const { clientId } = useParams();
  const location = useLocation();
  const isClientContext = location.pathname.includes('/clients/'); // Adjust this condition as needed

  return (
    <Group>
      <Menu shadow="md" width={220} trigger="hover" openDelay={100} closeDelay={400} position="right-start">
        <Menu.Target>
          <UnstyledButton>
            <Group gap={0} preventGrowOverflow wrap="nowrap" className={classes.menu}>
              <IconUsers size={17} stroke={2} className={classes.icon} />
              <Text size="lg" fw={600}>
                Clients
              </Text>
              <IconChevronDown style={{ width: rem(14), height: rem(14) }} stroke={1.5} />
            </Group>
          </UnstyledButton>
        </Menu.Target>

        <Menu.Dropdown className={classes.dropdown}>
          <Menu.Item>
            <Link to="clients" className={classes.link}>
              <IconTableShortcut size={14} className={classes.icon} />
              View All Clients
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="clients/new" className={classes.link}>
              <IconUserPlus size={14} className={classes.icon} />
              Add New Client
            </Link>
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      {isClientContext && ( // Conditionally render the Trips Profile menu
        <Menu shadow="md" width={220} trigger="hover" openDelay={100} closeDelay={400} position="right-start">
          <Menu.Target>
            <UnstyledButton>
              <Group gap={0} preventGrowOverflow wrap="nowrap" className={classes.menu}>
                <IconPlaneTilt size={17} stroke={2} className={classes.icon} />
                <Text size="lg" fw={600}>
                  Trips Profile
                </Text>
                <IconChevronDown style={{ width: rem(14), height: rem(14) }} stroke={1.5} />
              </Group>
            </UnstyledButton>
          </Menu.Target>

          <Menu.Dropdown className={classes.dropdown}>
            <Menu.Item>
              <Link to={`clients/${clientId}`} className={classes.link}>
                <IconTableShortcut size={14} className={classes.icon} />
                View Client&apos;s Trips
              </Link>
            </Menu.Item>
            <Menu.Item>
              <Link to={`clients/${clientId}/trip-profiles/new`} className={classes.link}>
                <IconUserPlus size={14} className={classes.icon} />
                Create New Client Trip
              </Link>
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}
    </Group>
  );
}

export default HeaderMenu;
